import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import LanguageSwitch from './LanguageSwitch';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeElevenHeader = ({ children, history, operator, loginData, t, onMyAccountClick }) => {
	operator = operator || CommonService.getLocal('op') || {};
	const centropuertoData = sessionStorage.getItem("centropuertoOperatorData")
	const parsedData = JSON.parse(centropuertoData);
	const language = sessionStorage.getItem("selectedLanguage")
	const headerLinks = language === 'en'
		? parsedData && parsedData.header_links_en || []    // Use English links if available
		: operator && operator.header_links || [];

	const SubLinks = data => {
		return (
			<div className="sub-nav">
				<style>
					.sub-nav-item:hover{'{'}
					background:{' '}
					{operator && operator.color_codes && operator.color_codes.secondary_color
						? operator.color_codes.secondary_color
						: ''}
					{'}'}
				</style>

				<div className="arrow-up" />
				{data &&
					data.map((sub, i) => {
						return (
							<a
								className="sub-nav-item"
								style={{ display: 'flex' }}
								key={sub.route}
								href={sub.route}
							>
								{sub.label}
							</a>
						);
					})}
			</div>
		);
	};

	return (
		<div className="themes-theme-eleven-header new-container ">
			<style>
				.nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
				margin-top:234px;
				{'}'}
				.header-box .header-details{'{'}
				background-color:{operator && operator.color_codes && operator.color_codes.header_color}
				{'}'}
			</style>
			<div className="header-left">
				<a href="/">
					<img
						src={operator && operator.header_logo ? operator.header_logo : ''}
						alt="logo"
						className="logo"
						id="main-logo"
						style={{
							width: operator && operator.header_logo_width ? operator.header_logo_width : 'auto',
							margin: '10px 0',
							height: 'auto',
						}}
					/>
				</a>
			</div>

			<div className="nav ">

				<div className="nav-wrapper">
					{headerLinks &&		// headerLinks.header_links &&
						(headerLinks.header || []).map((val, i) => {
							console.log("value", val)
							return (
								<a
									className={`nav-item header-right-link ${val.active ? 'active' : ''}`}
									key={i}
									style={{
										color:
											operator && operator.color_codes && operator.color_codes.links_color
												? operator.color_codes.links_color
												: 'white',
									}}
									onClick={() => {
										console.log('val', val);
										!val.sublinks && history.push(val.route);
									}}
								>
									{val.label}{' '}
									{val.sublinks && (
										<img
											src={getIcons('whiteDownArrow', operator)}
											alt={'whiteDownArrow'}
											style={{ width: 17 }}
										/>
									)}
									{val.sublinks && SubLinks(val.sublinks)}
								</a>
							);
						})
					}

					{
						window.location.pathname != '/my-account' && operator && operator.has_user_account && (
							<ul>
								<li>
									<div className="my-account-top font10">
										<a onClick={onMyAccountClick}>
											{CommonService.isLoggedIn(loginData) && loginData.image_link ? (
												<div className="dp-image-top">
													<img src={loginData.image_link} alt="DIS" />
												</div>
											) : (
												<div
													className={
														'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
													}
												>
													<img
														src={getIcons('userIcon', operator)}
														alt={t('TRANSLATIONS.USER_DOT')}
													/>
												</div>
											)}
										</a>
									</div>
								</li>
							</ul>
						)
					}
					<div className="nav-item header-right-link">
						<a href="https://www.instagram.com/centropuertocl/" target="blank">
							<img src="/assets/centropuerto/Home/instagram icon.svg" style={{ height: 22 }} />
						</a>
					</div>
					<div className="nav-item header-right-link" >
						<LanguageSwitch />
					</div>
				</div>
			</div>

			{children}
		</div>
	);
};

function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenHeader);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/components/ThemeElevenHeader.js